<template>
  <div>
    <v-card class="mx-auto mb-3" max-width="1000">
      <v-toolbar flat>
        <v-toolbar-title class="grey--text"
          >Operations / consultant view</v-toolbar-title
        >
        <div class="flex-grow-1"></div>
        <v-text-field
          class="mt-7"
          v-model="search"
          label="Search"
          required
          append-icon="search"
        ></v-text-field>
      </v-toolbar>

      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            label="Search first name"
            placeholder="First name"
            v-model="searchFirstName"
            filled
            class="ml-4"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="Search last name"
            placeholder="Last name"
            v-model="searchLastName"
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="Search email"
            placeholder="Email"
            v-model="searchEmail"
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="Search telephone"
            placeholder="Telephone"
            v-model="searchPhone"
            filled
            class="mr-4"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-expansion-panels multiple style="background-color: #c1d109">
      <v-expansion-panel
        v-for="(company, index) in filteredData"
        :key="index"
        :class="company.ragBooked"
      >
        <v-expansion-panel-header>
          <span class="title white--text">
            {{ company.name | capitalize }} -
            {{ company.eventName | capitalize }}
            <span v-if="company.event[0].type !== 'register'">
              <span class="white--text"
                >({{ company.percentBooked }}% booked)</span
              >
              <span class="white--text"
                >&nbsp;({{ company.bookedCount }}/{{ company.slotCount }})</span
              >
              <span class="subtitle-1 grey--text"></span>
            </span>
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <BookingWorkshop
              :events="company.event"
              v-if="
                company.event[0].type === 'workshop' ||
                  company.event[0].type === 'register'
              "
            ></BookingWorkshop>
            <BookingSlot
              :events="company.event"
              v-if="
                company.event[0].type === 'slot' ||
                  company.event[0].type === 'healthscreening' ||
                  company.event[0].type === 'virustesting'
              "
            ></BookingSlot>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import moment from "moment";
import BookingWorkshop from "@/components/BookingWorkshop.vue";
import BookingSlot from "@/components/BookingSlot.vue";

export default {
  components: {
    BookingWorkshop,
    BookingSlot
  },
  props: {
    eventData: Array
  },
  data() {
    return {
      createBookingDialog: false,
      createBookingLoader: false,
      search: "",
      searchCompany: "",
      searchFirstName: "",
      searchLastName: "",
      searchEmail: "",
      searchPhone: "",
      collectUserDatas: [],
      customField: {},
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000
      },
      companysHeaders: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Time", value: "time" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Number", value: "telNumber" },
        { value: "action", align: "right", sortable: false }
      ],
      companys: [],
      slotHeader: [
        { text: "Time", value: "time", align: "left" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Contact", value: "mobile" },
        { text: "DOB", value: "dob" },
        { value: "action", align: "right", sortable: false, width: "80px" }
      ],
      events: [],
      booking: [],
      days: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31"
      ],
      months: [
        { text: "January", value: "01" },
        { text: "February", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" }
      ],
      rules: {
        required: v => !!v || "This field is required.",
        email: v => /.+@.+\..+/.test(v) || "E-mail must be valid",
        confirmEmail: v =>
          v === this.booking.email || "Confirmation email must match email"
      }
    };
  },
  methods: {},
  async created() {
    const that = this;
    const events = this.eventData;

    // Company
    events.map((event, eventIndex) => {
      if (event.eventCompany) {
        that.events[eventIndex] = {
          ...event.eventCompany,
          bookedCount: 0,
          slotCount: 0,
          percentBooked: 0,
          ragBooked: "red",
          eventName: event.name,
          event: []
        };
        event.eventLocation.items.map(location => {
          location.eventSlotGroup.items.map(slotGroup => {
            // Add event 2nd
            that.events[eventIndex].event.push({
              name: event.name,
              code: event.code,
              type: event.type,
              status: event.status,
              iCalendar: event.iCalendar,
              location: location.postcode,
              addressLine1: location.addressLine1,
              town: location.town,
              room: slotGroup.room,
              date: new Date(slotGroup.date),
              capacity: slotGroup.capacity,
              attendance: event.attendance,
              booked: 0,
              percentBooked: 0,
              bookedCount: 0,
              slotCount: 0,
              slot: [],
              slotId: slotGroup.id
            });

            var customEventIndex = that.events[eventIndex].event.length - 1;

            // Slot group
            slotGroup.eventSlot.items.map((slot, slotIndex) => {
              // Add empty Slot
              let booking = {
                id: null,
                firstname: "",
                lastname: "",
                email: "",
                dob: "",
                mobile: "",
                time: slot.time,
                type: slot.type,
                booked: slot.booked,
                slotId: slot.id,
                iCalendar: event.iCalendar,
                cancelBooking:
                  slot.booked && slot.type === "SLOT" ? false : true
              };

              // Set slot Id
              that.events[eventIndex].event[customEventIndex].slotId = slot.id;

              // Create empty slots
              if (
                event.type === "healthscreening" ||
                event.type === "slot" ||
                event.type === "virustesting"
              ) {
                that.events[eventIndex].event[customEventIndex].slot.push(
                  booking
                );
              }

              // Bookings
              slot.eventBooking.items.map(eventBooking => {
                // Overwrite default slot with booked slot
                let customData = {};
                if (eventBooking.customData) {
                  customData = JSON.parse(eventBooking.customData);
                }
                if (event.type === "workshop" || event.type === "register") {
                  that.events[eventIndex].event[customEventIndex].slot.push({
                    ...booking,
                    ...eventBooking,
                    ...customData
                  });
                } else {
                  that.events[eventIndex].event[customEventIndex].slot[
                    slotIndex
                  ] = {
                    ...booking,
                    ...eventBooking,
                    ...customData
                  };
                }

                if (slot.type !== "BREAK" && slot.type !== "BLOOD") {
                  // Accumulate total bookings per company
                  slot.type === "SLOT" && that.events[eventIndex].bookedCount++;
                  slot.type === "workshop" &&
                    that.events[eventIndex].bookedCount++;

                  // Acumulate total bookings per event
                  slot.type === "SLOT" &&
                    that.events[eventIndex].event[customEventIndex]
                      .bookedCount++;
                  slot.type === "workshop" &&
                    that.events[eventIndex].event[customEventIndex]
                      .bookedCount++;
                }
              });

              if (slot.type !== "BREAK" && slot.type !== "BLOOD") {
                // Accumulate total slots per company
                slot.type === "SLOT" && that.events[eventIndex].slotCount++;
                if (slot.type === "workshop") {
                  that.events[eventIndex].slotCount =
                    that.events[eventIndex].slotCount + slotGroup.capacity;
                }

                // Accumulate total slots per event
                slot.type === "SLOT" &&
                  that.events[eventIndex].event[customEventIndex].slotCount++;
                if (slot.type === "workshop") {
                  that.events[eventIndex].event[customEventIndex].slotCount =
                    that.events[eventIndex].event[customEventIndex].slotCount +
                    slotGroup.capacity;
                }
              }
            });
          });
          // Calculate Percent Booked
          if (that.events[eventIndex].bookedCount) {
            that.events[eventIndex].percentBooked = Math.round(
              (that.events[eventIndex].bookedCount /
                that.events[eventIndex].slotCount) *
                100
            );
          }

          if (that.events[eventIndex].percentBooked < 40) {
            that.events[eventIndex].ragBooked = "red";
          } else if (that.events[eventIndex].percentBooked <= 75) {
            that.events[eventIndex].ragBooked = "amber";
          } else if (that.events[eventIndex].percentBooked > 75) {
            that.events[eventIndex].ragBooked = "green";
          }
        });
      }
    });

    that.events = that.events.filter(company => company.event.length > 0);
    that.events.map(company => {
      company.event.sort(
        // Sort by date
        (a, b) => new Date(a.date) - new Date(b.date)
      );
    });
    return;
  },
  computed: {
    filteredData() {
      const that = this;
      if (this.search) {
        return this.events.filter(
          company =>
            company.event.some(
              ({ code }) =>
                code.toLowerCase().indexOf(this.search.toLowerCase()) != -1
            ) ||
            company.event.some(
              ({ name }) =>
                name.toLowerCase().indexOf(this.search.toLowerCase()) != -1
            ) ||
            company.event.some(
              ({ room }) =>
                room.toLowerCase().indexOf(this.search.toLowerCase()) != -1
            ) ||
            (company.name &&
              company.name.toLowerCase().indexOf(this.search.toLowerCase()) !=
                -1) ||
            company.event.some(
              ({ date }) =>
                moment(date)
                  .format("Do MMMM YYYY")
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) != -1
            )
        );
      }

      if (this.searchCompany) {
        return this.events.filter(
          event =>
            event.company
              .toLowerCase()
              .indexOf(this.searchCompany.toLowerCase()) != -1
        );
      }

      if (this.searchFirstName) {
        return this.events.filter(company =>
          company.event.some(({ slot }) =>
            slot.some(
              ({ firstname }) =>
                firstname &&
                firstname
                  .toLowerCase()
                  .indexOf(this.searchFirstName.toLowerCase()) != -1
            )
          )
        );
      }

      if (this.searchLastName) {
        return this.events.filter(company =>
          company.event.some(({ slot }) =>
            slot.some(
              ({ lastname }) =>
                lastname &&
                lastname
                  .toLowerCase()
                  .indexOf(this.searchLastName.toLowerCase()) != -1
            )
          )
        );
      }

      if (this.searchEmail) {
        return this.events.filter(company =>
          company.event.some(({ slot }) =>
            slot.some(
              ({ email }) =>
                email &&
                email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) !=
                  -1
            )
          )
        );
      }

      if (this.searchPhone) {
        return this.events.filter(company =>
          company.event.some(({ slot }) =>
            slot.some(
              ({ mobile }) =>
                mobile && mobile.includes(parseInt(that.searchPhone))
            )
          )
        );
      }
      return this.events;
    },
    rangeOfYears() {
      const currentYear = new Date().getFullYear();
      let range = (start, stop, step) =>
        Array.from(
          { length: (stop - start) / step + 1 },
          (_, i) => start + i * step
        );
      range = range(currentYear - 15, currentYear - 90, -1);
      let dateRange = [];
      range.forEach(function(year) {
        dateRange.push({ text: year.toString(), value: year.toString() });
      });
      return dateRange;
    }
  }
};
</script>
<style scoped>
.red {
  background-color: #e53935 !important;
}
.amber {
  background-color: #ffb300 !important;
}
.green {
  background-color: #7cb342 !important;
}
</style>
